import { render, staticRenderFns } from "./Consumption.vue?vue&type=template&id=60f42554&scoped=true&"
import script from "./Consumption.vue?vue&type=script&lang=js&"
export * from "./Consumption.vue?vue&type=script&lang=js&"
import style0 from "./Consumption.vue?vue&type=style&index=0&id=60f42554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f42554",
  null
  
)

export default component.exports